<template>
  <HActionDialog class="redirect-modal">
    <template #header>
      <WTitle class="redirect-modal__header" size="xsmall" variant="heavy">{{
        title
      }}</WTitle>
    </template>
    <template #content>
      <div class="redirect-modal__text" v-html="content"></div>
      <div v-if="showReason" class="redirect-modal__reason">
        <WTextarea
          v-model="reason"
          label="Motivo do encaminhamento"
          placeholder="Escreva o motivo do encaminhamento"
          rows="4"
          required
        />
      </div>
      <div class="redirect-modal__footer">
        <WButton
          variant="primary"
          :disabled="isInvalid"
          @click="onClickRedirect"
        >
          {{ confirmLabel }}
        </WButton>
        <WButton variant="tertiary" @click="$emit('onCancel')">
          Cancelar
        </WButton>
      </div>
    </template>
  </HActionDialog>
</template>
<script>
import { WButton, WTextarea, WTitle } from '@alice-health/wonderland-vue'

import { HActionDialog } from '@/components/shared/atoms'
export default {
  components: { HActionDialog, WButton, WTextarea, WTitle },
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    showReason: {
      type: Boolean,
      default: false
    },
    confirmLabel: {
      type: String,
      default: 'Confirmar'
    }
  },
  emits: ['onRedirect', 'onCancel'],
  data() {
    return {
      reason: null
    }
  },
  computed: {
    isInvalid() {
      return this.showReason && !this.reason
    }
  },
  methods: {
    onClickRedirect() {
      const data = {}
      if (this.showReason) {
        data.reason = this.reason
      }

      this.$emit('onRedirect', data)
    }
  }
}
</script>
<style lang="scss" scoped>
.redirect-modal {
  &__header {
    color: var(--sys-color-content-primary);
    padding: 0;
    margin: 0;
  }
  &__text {
    max-width: 500px;
  }
  &__reason {
    margin-top: var(--gl-spacing-03);
  }
  &__footer {
    display: flex;
    gap: var(--gl-spacing-03);
    margin-top: var(--gl-spacing-08);
  }
}
</style>
